export default function Hero() {
  return (
    <section
      style={{
        backgroundImage: `url(/mecanica.jpg)`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
      className="text-white text-center py-20"
    >
      <div className="mx-auto backdrop-blur-5 py-10">
        <h2 className="text-3xl font-bold font-bold">Confiança e qualidade em Jaú</h2>
        <p className="mt-4 text-lg">Com padrão Bosch Service</p>
        <a href="#contato" className="mt-6 inline-block bg-green-500 px-6 py-3 rounded-lg font-bold hover:bg-green-600">
          Peça um orçamento pelo WhatsApp
        </a>
      </div>
    </section>
  );
}
